import { ArrowDownToLine, CirclePlus, Pencil, TrashBin } from '@gravity-ui/icons';
import { Button, Icon, Tooltip } from '@gravity-ui/uikit';
import { DeleteBlankModal } from '../../blank-table/delete-blank-modal';
import { DELETE_BLANK, DOWNLOAD_BLANK, EDIT_BLANK } from '../../constants';
import styles from './styles.module.scss';

export const BlankBlockMenu = ({
	person,
	handleAddRating,
	handleEditBlank,
	handleDownloadBlank,
	setOpenDeleteModal,
	isDeleting,
	openDeleteModal,
	handleDeleteBlank,
}: any) => {
	return (
		<div>
			<Button view="outlined" onClick={() => handleAddRating(person.id)} size="l">
				<Icon data={CirclePlus} size={16} />
				Добавить оценку
			</Button>

			<Tooltip
				className={styles.blankTable__action__tooltip}
				content={EDIT_BLANK}
				placement="top"
				openDelay={500}
			>
				<Button
					view="flat"
					onClick={() => {
						handleEditBlank(person.id);
					}}
					size="l"
				>
					<Icon data={Pencil} size={16} />
				</Button>
			</Tooltip>

			<Tooltip
				className={styles.blankTable__action__tooltip}
				content={DOWNLOAD_BLANK}
				placement="top"
				openDelay={500}
			>
				<Button view="flat" size="l" onClick={() => handleDownloadBlank(person.id)}>
					<Icon data={ArrowDownToLine} size={16} />
				</Button>
			</Tooltip>

			<Tooltip
				className={styles.blankTable__action__tooltip}
				content={DELETE_BLANK}
				placement="top"
				openDelay={500}
			>
				<Button view="flat" onClick={() => setOpenDeleteModal(true)} disabled={isDeleting} size="l">
					{isDeleting ? 'Удаление...' : <Icon data={TrashBin} size={16} />}
				</Button>
			</Tooltip>
			<DeleteBlankModal
				open={openDeleteModal}
				setOpen={setOpenDeleteModal}
				onConfirm={() => handleDeleteBlank(person.id)}
			/>
		</div>
	);
};
